import { useApiFetch } from '~/composables/useApiFetch';
import type {
  App,
  AppListResponse,
  ConfigsResponse,
  CreateAppRequest,
  ToggleAppChatUiActiveRequest,
  UpdateAppRequest,
} from '~/types/app';

const DEFAULT_APP_LIST_PAGE_SIZE = 12;

export interface GetAppListApiParams {
  page_on?: number;
  page_size?: number;
}

export async function getAppListApi(params?: GetAppListApiParams): Promise<AppListResponse> {
  const page_on = params?.page_on ?? 1;
  const page_size = params?.page_size ?? DEFAULT_APP_LIST_PAGE_SIZE;
  const query = new URLSearchParams({
    page_on: String(page_on),
    page_size: String(page_size),
  });
  const response = await useApiFetch(`/app/list?${query.toString()}`, {
    method: 'GET',
    requireAuth: true,
  });
  return await response.json();
}

export async function getAppApi(appId: number): Promise<App> {
  const response = await useApiFetch(`/app?id=${appId}`, {
    method: 'GET',
    requireAuth: true,
  });
  return await response.json();
}

export async function deleteAppApi(appId: number): Promise<boolean> {
  const response = await useApiFetch(`/app?id=${appId}`, {
    method: 'DELETE',
    requireAuth: true,
  });
  return await response.json();
}

export async function createAppApi(appRequest: CreateAppRequest): Promise<number> {
  const response = await useApiFetch('/app', {
    method: 'POST',
    requireAuth: true,
    body: JSON.stringify(appRequest),
    // customHeaders: {
    //     'ORGUUID': '41eb17eb-f4db-42a5-9f72-6ed6793d5c79'
    // },
  });
  return await response.json();
}

export async function updateAppApi(appRequest: UpdateAppRequest): Promise<App> {
  const response = await useApiFetch('/app', {
    method: 'PUT',
    requireAuth: true,
    body: JSON.stringify(appRequest),
  });
  return await response.json();
}

export async function toggleAppChatUiActiveApi(
  appRequest: ToggleAppChatUiActiveRequest
): Promise<App> {
  const response = await useApiFetch('/app/enable_chat_ui', {
    method: 'PUT',
    requireAuth: true,
    body: JSON.stringify(appRequest),
  });
  return await response.json();
}

/**
 * 獲取系統配置
 * @returns 系統配置資訊，包含 is_open_invite 等設定
 */
export async function getConfigsApi(): Promise<ConfigsResponse> {
  const response = await useApiFetch('/configs/', {
    method: 'GET',
    requireAuth: false, // 配置 API 不需要認證，註冊流程中可調用
  });
  return await response.json();
}
